import { render, staticRenderFns } from "./GlobalPdf.vue?vue&type=template&id=fb22dd88&"
import script from "./GlobalPdf.vue?vue&type=script&lang=js&"
export * from "./GlobalPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports